import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-[#D5DAE0]" data-id="element-19" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-20" data-mp="22divwowf5p6l">
        <div className="text-center mb-16" data-id="element-21" data-mp="1ydi7qcjipzmc">
          <p className="text-[#B8480A] font-bold tracking-widest uppercase mb-2" data-id="element-22" data-mp="1yet9k6tekxat">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-[#16191E]" data-id="element-23" data-mp="15pw10vezuev9">
            <span className="text-[#E8590C]" data-id="element-24" data-mp="1jgitw6y2pajf">5</span> EXCLUSIVE WELDING{' '}
            <span className="text-[#E8590C]" data-id="element-25" data-mp="1jilsvgh7ee0a">INSTRUCTOR BONUSES</span>
          </h2>
          <p className="text-lg text-slate-700/80 max-w-3xl mx-auto mt-5" data-id="element-26" data-mp="1enxzp4b98vfd">
            The six main volumes give you visual training material for every core welding teaching area. And the five
            bonuses add practical tools to help you set machines with confidence, script your demonstrations, assign
            practice projects and coupon exercises, train students to identify weld defects, and assess them with clear
            competency checklists, rubrics and certificates.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-27" data-mp="2ogzj400l8ane">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-[#D5DAE0] rounded-2xl p-8 shadow-sm shadow-[#16191E]/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="1qt8m615csgsw" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-[#16191E] text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-29" data-mp="3c8wll0i5dqbu">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-[#E7EBEF] border border-[#F28A2E] rounded-full flex items-center justify-center text-[#E8590C] mb-4" data-id="element-30" data-mp="1h589h5mzrve6">
                <Gift size={24} data-id="element-31" data-mp="1q4d8ed2gtqqv" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-[#16191E]" data-id="element-32" data-mp="1q1r0udfkrb8n">{bonus.title}</h3>
              <p className="text-[#B8480A] text-sm font-semibold mb-4 border-l-4 border-[#F28A2E] pl-4" data-id="element-33" data-mp="1m0nhhgybix2o">
                {bonus.subtitle}
              </p>
              {bonus.referenceValueCents !== undefined && <p className="flex flex-wrap items-baseline gap-x-2 text-sm mb-4" data-id="element-34" data-mp="174zbpndcq1wo">
                  <span className="text-slate-500" data-id="element-35" data-mp="12eiv5ue8i063">Reference value:</span>
                  <span className="text-slate-500 line-through" data-id="element-36" data-mp="12d7p1nxbggbt">
                    {formatUsd(bonus.referenceValueCents)}
                  </span>
                  <span className="font-extrabold text-green-700 uppercase tracking-wide" data-id="element-37" data-mp="anusuf0tqoqu">
                    Included free
                  </span>
                </p>}
              {bonus.intro && <p className="text-slate-700 text-sm mb-4 leading-relaxed" data-id="element-38" data-mp="5b67g79mfxig">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-[#16191E] font-semibold text-sm mb-3" data-id="element-39" data-mp="3rpfw8hhgr7jr">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-40" data-mp="ja5mqob8v01y">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-41" data-mp="eaj9wfzbvlto">
                        <CheckCircle2 size={16} className="text-[#E8590C] shrink-0 mt-0.5" data-id="element-42" data-mp="ecm8vpigkpaj" />
                        <span className="text-slate-700 text-sm" data-id="element-43" data-mp="2u41s5qtiz8h3">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.detailedBullets && <>
                  <p className="text-[#16191E] font-semibold text-sm mb-3" data-id="element-44" data-mp="3ah6grssr4tdc">{bonus.bulletsIntro}</p>
                  <ul className="mb-6 space-y-3" data-id="element-45" data-mp="35hk8zyvp05bx">
                    {bonus.detailedBullets.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-46" data-mp="30kldpd0alsc5">
                        <CheckCircle2 size={16} className="text-[#E8590C] shrink-0 mt-0.5" data-id="element-47" data-mp="21wm35r6yqfl" />
                        <div data-id="element-48" data-mp="3t7ejwawgbjtj">
                          <span className="block text-[#16191E] font-bold text-sm" data-id="element-49" data-mp="3t9939ks2r3vi">{item.title}</span>
                          <span className="block text-slate-700 text-sm" data-id="element-50" data-mp="3o79zi9sfa4y1">{item.detail}</span>
                        </div>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-[#16191E] font-semibold text-sm mb-3" data-id="element-51" data-mp="27ttlsrq9fpum">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-52" data-mp="sbn9ryjs9i6h">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-[#16191E] font-semibold text-sm bg-[#E7EBEF] border border-[#D5DAE0] rounded-lg px-3 py-2" data-id="element-53" data-mp="x9p27a33mtum">
                        {bullet}
                      </li>)}
                  </ul>
                  {bonus.secondaryNote && <p className="-mt-3 mb-6 text-slate-700 text-sm italic" data-id="element-54" data-mp="1g1hl2bogeyom">{bonus.secondaryNote}</p>}
                </>}

              <div className="mt-auto space-y-3" data-id="element-55" data-mp="1kzsxmu64vnaj">
                {bonus.system && <div data-id="element-56" data-mp="3htw9ltli71e0">
                    <p className="text-[#16191E] font-semibold text-sm mb-2" data-id="element-57" data-mp="3hupboh9ip2pt">{bonus.systemLabel}</p>
                    <p className="text-[#16191E] font-bold text-xs sm:text-sm tracking-wide bg-[#E7EBEF] border-l-4 border-[#F28A2E] rounded-lg px-3 py-2" data-id="element-58" data-mp="3mts677rvfqjj">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-[#F3F5F7] border border-[#D5DAE0] border-l-4 border-l-[#16191E] rounded-xl p-4" data-id="element-59" data-mp="3oqgzqq23d9c9">
                    <span className="text-[#16191E] font-bold block mb-1" data-id="element-60" data-mp="3jsfgo54o1a0s">RESULT</span>
                    <p className="text-slate-700 text-sm" data-id="element-61" data-mp="1idbjdofcpqu">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-[#D5DAE0]" data-id="element-62" data-mp="b97yyldepvdv">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-[#16191E] font-extrabold text-base tracking-wide' : 'text-[#16191E] font-semibold text-sm italic'} data-id="element-63" data-mp="6byc9dhejxtq" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function formatUsd(cents: number): string {
  return `$${(cents / 100).toFixed(2)} USD`;
}